<template>
  <div style="width: 100%;height: 100%">
    <div v-if="design" class="activeMask" />
    <div :style="{ width: width + 'px', height: height + 'px' }" :id="uuid" />
  </div>
</template>

<script>
import G6 from '@antv/g6';
import { getDataJson, pollingRefresh } from "@/utils/refresh-cpt-data";

export default {
  name: "cpt-g6-dom",
  title: '关系图',
  icon: 'el-icon-cherry',
  group: 'chart',
  props: {
    width: Number,
    height: Number,
    option: Object,
    design: Boolean,
    current: Object
  },
  computed: {
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  watch: {
    'option.attribute.refreshFlag': {
      handler() {
        const staticData = JSON.parse(this.option.cptDataForm.dataText);
        this.loadChart(this.option.attribute, staticData);// 编辑完成后使用静态数据，不使用API
      }
    },
    width() {
      this.graph.changeSize(this.width, this.height)
    },
    height() {
      this.graph.changeSize(this.width, this.height)
    },
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  data() {
    return {
      uuid: null,
      graph: null,
      cptData: {},
      timer: null
    }
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    const attr = this.option.attribute
    if (!attr.globalDataReload) attr.globalDataReload = [0]
  },
  mounted() {
    let element = document.getElementById(this.uuid)
    if (!element) return

    const modes = {
      default: ['drag-canvas', 'drag-node'],
      custom: []
    }

    const that = this;
    const tooltip = new G6.Tooltip({
      trigger: 'click',
      itemTypes: ['node', 'edge'],
      shouldBegin: (evt) => {
        let state = true;
        const id = evt.item.getModel().id
        if (that.cptData.alertNodeIds && that.cptData.alertNodeIds.indexOf(id) !== -1) {
          state = false
        }
        return !state
      },
      getContent: (e) => {
        const id = e.item.getModel().id
        const outDiv = document.createElement('div');
        outDiv.innerHTML = `
      <h4>${e.item.getModel().label || id}</h4>
      <div>状态: 告警</div>
      <div>告警内容: --</div>
      `;
        return outDiv;
      },
    });

    this.graph = new G6.Graph({ container: this.uuid, width: this.width, height: this.height, modes: modes, plugins: [tooltip] });
    this.graph.on('node:click', (evt) => {
      console.log(evt.item._cfg.model)
    });
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }

  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm) {
      pollingRefresh(this.uuid, cptDataForm, () => this.loadData(cptDataForm))
    },
    loadData(cptDataForm) {
      getDataJson(cptDataForm, '', (res) => {
        this.cptData = res;
        this.loadChart(this.option.attribute);
      })
    },
    loadChart(attribute, data) {
      const that = this;
      const g6Data = data ? data : that.cptData;
      if (attribute.draggable) {
        that.graph && that.graph.setMode('default')
      } else {
        that.graph && that.graph.setMode('custom')
      }

      if (attribute.layout !== 'auto' && attribute.layout !== 'custom') {
        const layout = {
          type: attribute.layout,
          rankdir: attribute.rankdir,
        }
        that.graph.updateLayout(layout);
      } else {
        that.graph && that.graph.destroyLayout();
      }

      that.graph.changeSize(this.width, this.height)
      that.graph.data(g6Data);// 读取数据
      that.graph.render();// 渲染图
      that.nodeAlert();
    },
    nodeAlert() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      let idsList = this.cptData.alertNodeIds;
      if (!idsList) return;
      const that = this;
      let alertNodes = []
      for (let i = 0; i < idsList.length; i++) {
        const id = idsList[i]
        const node = that.cptData.nodes.find(item => { return item.id === id })
        if (node && node.img) {
          alertNodes.push(JSON.parse(JSON.stringify(node)))
        }
      }
      if (alertNodes.length > 0) {
        let runed = false
        this.timer = setInterval(() => {
          for (let i = 0; i < alertNodes.length; i++) {
            const temp = alertNodes[i]
            let img = runed ? temp.img : '/file/imgPool/fb42df40807b4d858c201c96c53721a1.svg'
            that.graph.updateItem(temp.id, { img: img }, false)
            that.graph.refreshItem(temp.id);
          }
          runed = !runed
        }, 500)
      }
    }
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped>
.activeMask {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1801;
}
</style>
